import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(
  () => import("../components/transcript/generate/main")
);

const GenerateTranscript = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default GenerateTranscript;
